import type {
  CredentialsRequirementType,
  OAuthProviderType,
  ServerDeploymentType,
  ServerFeature,
} from '@affine/graphql';

export interface ServerMetadata {
  id: string;

  baseUrl: string;
}

export interface ServerConfig {
  serverName: string;
  features: ServerFeature[];
  oauthProviders: OAuthProviderType[];
  type: ServerDeploymentType;
  initialized?: boolean;
  version?: string;
  credentialsRequirement: CredentialsRequirementType;
}
export enum CloudProvider {
  TENCENT = 'TENCENT',
  ALIYUN = 'ALIYUN',
  TENCENT_CN = 'TENCENT_CN',
}

export enum EApiPrefix {
  DEVELOPMENT = 'development',
  DEV = 'dev',
  PROD = 'prod',
  PRODUCTION = 'production',
}

export interface CreateAddonCheckoutSessionInput {
  productId: number;
  price: string;
  successCallbackLink: string;
}
export type AddonPrice = {
  channelProductId: string;
  giftQuantity: number;
  id: number;
  originalPrice: string;
  pricingCurrency: string;
  productPackage: number;
  productType: number;
  quantity: number;
  sellingPrice: string;
  tag: string;
  totalQuantity: number;
  unit: string;
};
export type AddonPriceFromServer = {
  channelProductId: string;
  giftQuantity: number;
  id: number;
  originalPrice: number;
  pricingCurrency: string;
  productPackage: number;
  productType: number;
  quantity: number;
  sellingPrice: number;
  tag: string;
  totalQuantity: number;
  unit: string;
};
